import React from "react";
import { useTranslation } from "react-i18next";
import Elements from "./Elements";

const ElementList = ({
	errors,
	modelData,
	setModelData,
	setErrors,
	disableInput,
	access,
	translations,
}) => {
	const { t } = useTranslation();
	const onErrorChange = (
		updatedData,
		modelName,
		errorName,
		elementID,
		resolved
	) => {
		// Functional updaters so concurrent calls (e.g. when translation auto-matches
		// rows across multiple sections at once) don't overwrite each other via
		// stale closure-captured state. The resolved count is computed inside
		// Elements (which holds the destination dropdown), so it reflects the
		// translated-name vs destination-name comparison rather than just
		// "is anything set".
		setModelData((prev) => ({
			...prev,
			data: { ...prev.data, [modelName]: updatedData },
		}));
		if (elementID !== "roleID" && typeof resolved === "number") {
			setErrors((prev) => ({
				...prev,
				[errorName]: { ...prev[errorName], resolved },
			}));
		}
	};
	return (
		<>
			<Elements
				name="Action"
				title={t("label.actionRequired")}
				entityLabel={t("entity.actionRequired")}
				errors={errors.actions}
				getApi="/api/actions"
				patchApi="/api/ModelImportActions"
				siteAppID={modelData.data.siteAppID}
				mainData={modelData.data.modelImportActions}
				errorName="actions"
				modelName="modelImportActions"
				elementID="actionID"
				onErrorResolve={onErrorChange}
				disableInput={disableInput}
				access={access}
				translations={translations}
			/>
			<Elements
				name="Lubricant"
				title={t("label.lubricants")}
				entityLabel={t("entity.lubricant")}
				errors={errors.lubricants}
				getApi="/api/Lubricants"
				patchApi="/api/ModelImportLubricants"
				siteAppID={modelData.data.siteAppID}
				mainData={modelData.data.modelImportLubricants}
				errorName="lubricants"
				modelName="modelImportLubricants"
				elementID="lubricantID"
				onErrorResolve={onErrorChange}
				disableInput={disableInput}
				access={access}
				translations={translations}
			/>
			<Elements
				name="Operating Mode"
				title={t("label.operatingModes")}
				entityLabel={t("entity.operatingMode")}
				errors={errors.operatingModes}
				getApi="/api/OperatingModes"
				patchApi="/api/ModelImportOperatingModes"
				siteAppID={modelData.data.siteAppID}
				mainData={modelData.data.modelImportOperatingModes}
				errorName="operatingModes"
				modelName="modelImportOperatingModes"
				elementID="operatingModeID"
				onErrorResolve={onErrorChange}
				disableInput={disableInput}
				access={access}
				translations={translations}
			/>
			<Elements
				name="System"
				title={t("label.systems")}
				entityLabel={t("entity.system")}
				errors={errors.systems}
				getApi="/api/Systems"
				patchApi="/api/ModelImportSystems"
				siteAppID={modelData.data.siteAppID}
				mainData={modelData.data.modelImportSystems}
				errorName="systems"
				modelName="modelImportSystems"
				elementID="systemID"
				onErrorResolve={onErrorChange}
				disableInput={disableInput}
				access={access}
				translations={translations}
			/>
			<Elements
				name="Role"
				title={t("label.roles")}
				entityLabel={t("entity.role")}
				errors={errors.roles}
				getApi="/api/Roles"
				patchApi="/api/ModelImportRoles"
				siteAppID={modelData.data.siteAppID}
				mainData={modelData.data.modelImportRoles}
				errorName="roles"
				modelName="modelImportRoles"
				elementID="roleID"
				onErrorResolve={onErrorChange}
				disableInput={disableInput}
				access={access}
				translations={translations}
			/>
		</>
	);
};
// React memo is used as this component is delaying onChange in text change
export default React.memo(ElementList);
